import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  components: {
    MuiContainer: {
      styleOverrides: {
        root: {
          maxWidth: "100% !important",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          "&.MuiButton-contained": {
            background: "rgb(35, 136, 249)",
            color: "#fff",
            border: "1px solid rgb(35, 136, 249)",
            fontWeight: "600",
            borderRadius: "4px",
            padding: "6px 20px",
            textTransform: "capitalize",
            "&:hover": {
              background: "rgb(35, 136, 249)",
              opcity: "0.8",
            },
          },
          "&.Mui-disabled": {
            color: "#1976d2",
            borderColor: "#1976d2",
            opacity: "0.6",
          },
          "&.MuiButton-outlined": {
            padding: "6px 15px",
          },
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          "& .MuiInputBase-formControl": {
            "& input": {
              padding: "10px",
            },
          },
        },
      },
    },
  },
});

export default theme;
